/* La Klas auktionsoversigt. Henter status, bud og sluttid for hver auktion fra auktions-appen (Webkul)
   via samme kald som appens egen budboks, og sorterer auktionerne i Live nu, Kommer snart og Afsluttede.
   Al tekst fra appen indsættes som tekst, aldrig som HTML. */
(() => {
  const root = document.querySelector('[data-lk-auo]');
  const dataEl = document.querySelector('[data-lk-auo-data]');
  if (!root || !dataEl) return;
  let items = [];
  try { items = JSON.parse(dataEl.textContent) || []; } catch (e) { items = []; }
  const shop = root.dataset.shop;
  const num = new Intl.NumberFormat('da-DK', {maximumFractionDigits: 0});
  const day = new Intl.DateTimeFormat('da-DK', {weekday: 'short', day: 'numeric', month: 'short', timeZone: 'Europe/Copenhagen'});
  const hm = new Intl.DateTimeFormat('da-DK', {hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Copenhagen'});
  const cap = s => s.charAt(0).toUpperCase() + s.slice(1);
  const dayTxt = d => cap(day.format(d)).replace(/\.$/, '').replace(/\s+/g, ' ') + '.';
  const amount = s => { const m = String(s || '').replace(/\.(?=\d{3}\b)/g, '').match(/(\d[\d\s]*)/); return m ? Number(m[1].replace(/\s/g, '')) : NaN; };
  const left = ms => { const m = Math.max(0, Math.floor(ms / 60000)), d = Math.floor(m / 1440), h = Math.floor(m % 1440 / 60); return d > 1 ? d + ' dage tilbage' : d === 1 ? '1 dag tilbage' : h > 0 ? h + ' t tilbage' : (m % 60) + ' min tilbage'; };
  const el = (tag, cls, txt) => { const e = document.createElement(tag); if (cls) e.className = cls; if (txt != null && txt !== '') e.textContent = txt; return e; };

  /* One request at a time: the app answers through a fixed global function. */
  function fetchOne(id, wait) {
    return new Promise(resolve => {
      const q = new URLSearchParams({p: 'wk_ajax_process', callback: 'biddingform', shop_name: shop, prod_id: String(id), cust_id: '', page: 'products', timediff: String(new Date().getTimezoneOffset()), general_config: 'ZmFsc2U%3D', auction_config: 'ZmFsc2U%3D', widget_config: 'false', theme_colors: 'ZmFsc2U%3D', 'active_currency[active]': 'DKK', 'active_currency[rate]': '1.0', rate_from: '0', rate_to: '0', _: String(Date.now())});
      const s = document.createElement('script');
      let done = false;
      const finish = v => { if (done) return; done = true; clearTimeout(t); window.biddingform = function () {}; s.remove(); resolve(v); };
      const t = setTimeout(() => { window.lkAuoTimedOut = true; finish(null); }, wait);
      window.biddingform = html => finish(typeof html === 'string' ? html : null);
      s.onerror = () => finish(null);
      s.src = 'https://sp-auction.webkul.com/index.php?' + q.toString();
      document.head.appendChild(s);
    });
  }

  function parse(html) {
    if (!html) return null;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const wk = doc.body;
    const txt = sel => { const n = wk.querySelector(sel); return n ? n.textContent.replace(/\s+/g, ' ').trim() : ''; };
    if (!wk.querySelector('#show_bids, #current_bid, #start_bid, .pa-finished-msg')) return {status: 'soon'};
    const countTxt = txt('#show_bids');
    const count = countTxt ? Number((countTxt.match(/\d+/) || [0])[0]) : 0;
    const current = amount(txt('#current_bid'));
    const start = amount(txt('#start_bid'));
    const finished = [...wk.querySelectorAll('.pa-finished-msg')].some(n => !n.classList.contains('pa-hide') && n.style.display !== 'none');
    const endM = html.match(/time_left_to_end\s*=\s*(-?\d+)/);
    const startM = html.match(/time_left_to_start\s*=\s*(\d+)/);
    const end = endM ? new Date(Date.now() + Number(endM[1]) * 1000) : null;
    const begins = startM ? new Date(Date.now() + Number(startM[1]) * 1000) : null;
    let status = 'live';
    if (finished || (end && end.getTime() <= Date.now())) status = 'done';
    else if (begins && begins.getTime() > Date.now()) status = 'soon';
    return {status, count, current, start, end, begins};
  }

  function bigCard(it, d) {
    const li = el('li');
    const a = el('a', 'lk-auo__card'); a.href = it.url;
    const media = el('div', 'lk-auo__img' + (it.fit === 'contain' ? ' lk-auo__img--contain' : ''));
    if (it.img) { const img = el('img'); img.src = it.img; img.alt = ''; img.loading = 'lazy'; media.appendChild(img); }
    if (d && d.status) {
      const chip = el('span', 'lk-auo__chip'); chip.appendChild(el('i'));
      chip.appendChild(document.createTextNode(d.status === 'live' && d.end ? 'Live · ' + left(d.end - Date.now()) : d.status === 'live' ? 'Live' : ''));
      if (chip.textContent) media.appendChild(chip);
    }
    a.appendChild(media);
    const body = el('div', 'lk-auo__body');
    body.appendChild(el('p', 'lk-auo__for', (it.kicker ? it.kicker + ' · ' : '') + 'Til fordel for ' + (it.for || 'La Klas')));
    body.appendChild(el('h3', '', it.title));
    if (it.short) body.appendChild(el('p', 'lk-auo__short', it.short));
    if (d && d.status === 'live') {
      const dl = el('dl', 'lk-auo__facts');
      const add = (dt, dd, big, small) => { const w = el('div'); w.appendChild(el('dt', '', dt)); const v = el('dd', big ? 'big' : '', dd); if (small) { v.appendChild(el('br')); v.appendChild(document.createTextNode(small)); } w.appendChild(v); dl.appendChild(w); };
      const amt = d.count > 0 && d.current > 0 ? d.current : d.start;
      add(d.count > 0 ? 'Højeste bud' : 'Startbud', Number.isFinite(amt) && amt > 0 ? num.format(amt) + ' kr.' : '–', true);
      if (d.end) add('Slutter', dayTxt(d.end), false, 'kl. ' + hm.format(d.end));
      add('Bud', String(d.count || 0));
      body.appendChild(dl);
    }
    const cta = el('div', 'lk-auo__cta'); cta.appendChild(el('span', 'lk-auo__btn', d && d.status === 'live' ? 'Se auktionen og byd' : 'Se auktionen'));
    body.appendChild(cta);
    a.appendChild(body); li.appendChild(a);
    return li;
  }

  function row(it, d) {
    const li = el('li');
    const a = el('a', 'lk-auo__row' + (d.status === 'done' ? ' lk-auo__row--done' : '')); a.href = it.url;
    if (it.thumb) { const img = el('img'); img.src = it.thumb; img.alt = ''; img.loading = 'lazy'; a.appendChild(img); } else a.appendChild(el('span', 'lk-auo__ph'));
    const mid = el('div'); mid.appendChild(el('h3', '', it.title));
    let meta;
    if (d.status === 'done') meta = d.end ? 'Sluttede ' + dayTxt(d.end).toLowerCase() : 'Afsluttet';
    else meta = d.begins ? 'Starter ' + dayTxt(d.begins).toLowerCase() + ' kl. ' + hm.format(d.begins) : 'Starter snart';
    mid.appendChild(el('p', '', meta + ' · Til fordel for ' + (it.for || 'La Klas')));
    a.appendChild(mid);
    const amt = el('div', 'lk-auo__amt');
    if (d.status === 'done') { if (d.count > 0 && d.current > 0) { amt.appendChild(document.createTextNode(num.format(d.current) + ' kr.')); amt.appendChild(el('small', '', 'Vindende bud')); } else amt.appendChild(el('small', '', 'Ingen bud')); }
    else if (Number.isFinite(d.start) && d.start > 0) { amt.appendChild(document.createTextNode(num.format(d.start) + ' kr.')); amt.appendChild(el('small', '', 'Startbud')); }
    a.appendChild(amt); li.appendChild(a);
    return li;
  }

  const group = name => root.querySelector('[data-group="' + name + '"]');
  function fill(name, list, make) {
    const g = group(name); if (!g || !list.length) return;
    const ul = g.querySelector('[data-group-list]'); ul.replaceChildren(...list.map(make));
    g.querySelector('[data-group-count]').textContent = list.length === 1 ? '1 auktion' : list.length + ' auktioner';
    g.hidden = false;
  }

  async function run() {
    const loading = root.querySelector('[data-lk-auo-loading]');
    if (!items.length) { loading.hidden = true; root.querySelector('[data-lk-auo-empty]').hidden = false; return; }
    const results = [];
    /* At most 8 s per auction and 12 s in total; anything not fetched by then is shown as a plain card. */
    const deadline = Date.now() + 12000;
    for (const it of items) {
      const left = deadline - Date.now();
      /* After a timeout a late answer could reach the next request's callback, so stop fetching rather than risk wrong numbers. */
      const go = left > 300 && !window.lkAuoTimedOut;
      results.push({it, d: go ? parse(await fetchOne(it.id, Math.min(8000, left))) : null});
    }
    loading.hidden = true;
    if (results.every(r => !r.d)) {
      fill('all', results.map(r => r.it), it => bigCard(it, null));
      return;
    }
    /* An auction whose status could not be fetched is shown as a plain card after the live ones, never as "Kommer snart". */
    /* Auctions picked in the theme editor (Superdysten) stay on top; the rest follow by end time. */
    const live = results.filter(r => r.d && r.d.status === 'live').sort((a, b) => (b.it.pin ? 1 : 0) - (a.it.pin ? 1 : 0) || (a.d.end || 0) - (b.d.end || 0));
    const unknown = results.filter(r => !r.d).sort((a, b) => (b.it.pin ? 1 : 0) - (a.it.pin ? 1 : 0));
    const soon = results.filter(r => r.d && r.d.status === 'soon').sort((a, b) => (a.d.begins || Infinity) - (b.d.begins || Infinity));
    const done = results.filter(r => r.d && r.d.status === 'done').sort((a, b) => (b.d.end || 0) - (a.d.end || 0)).slice(0, 12);
    fill('live', [...live, ...unknown], r => bigCard(r.it, r.d));
    fill('soon', soon, r => row(r.it, r.d));
    fill('done', done, r => row(r.it, r.d));
    if (!live.length && !unknown.length) root.querySelector('[data-lk-auo-empty]').hidden = false;
  }
  /* Last resort: if anything unexpected fails, show every auction as a plain card instead of an endless loader. */
  run().catch(() => {
    root.querySelector('[data-lk-auo-loading]').hidden = true;
    root.querySelectorAll('[data-group]').forEach(g => { g.hidden = true; });
    fill('all', items, it => bigCard(it, null));
  });
})();
